import type { AdminSiteUpdateRequest } from '@lib/requests/site';
import type { SiteWithConfigResponse } from '@lib/responses/site';
import { FindAdminSitesForUserOutput } from '@snap-types/features/admin/actions/find-admin-sites-for-user';

import type { API } from '../api';

export class AdminSiteService {
  constructor(private api: API) {}

  getAll = () => {
    return this.api.get<FindAdminSitesForUserOutput>('/admin/sites');
  };

  update = (id: string, site: AdminSiteUpdateRequest) => {
    return this.api.put<SiteWithConfigResponse>(`/admin/sites/${id}`, site);
  };
}
